<template>
  <div class="partner-filter">
    <div class="partner-filter__title">
      {{ $tPartners('agent_in_your_network') }}
    </div>
    <div class="partner-filter__period-title  d-md-none">
      {{ $tPartners('agent_in_your_network') }}
    </div>

    <div class="partner-filter__period-wrap">
      <button @click.prevent="onDateRangePrev"
              class="partner-filter__period-btn  _prev  base-btn  base-btn--outline-grey--blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
      <DatePiker :value="dateRange"
                 format="DD.MM.YYYY"
                 range
                 range-separator=" - "
                 value-type="format"
                 @input="onDateRangeInput"
                 class="partner-filter__period-datepicker"/>

      <button @click.prevent="onDateRangeNext"
              class="partner-filter__period-btn  _next  base-btn  base-btn--outline-grey--blue">
        <BaseSvg name="ico-arrow-light"/>
      </button>
    </div>
  </div>
</template>

<script>
  import DatePiker from '@/components/DatePiker'

  export default {
    name: 'PartnerFilter',
    components: {
      DatePiker
    },
    inject: [
      'PARTNERS_DATE_FROM',
      'PARTNERS_DATE_TO',
      'DEFAULT_DATE_RANGE',
      'formatDate',
    ],
    data() {
      return {}
    },
    computed: {
      routeDateRange() {
        const query = this.$route.query

        return [query[this.PARTNERS_DATE_FROM], query[this.PARTNERS_DATE_TO]]
      },
      dateRange() {
        const routeDateRange = this.routeDateRange

        if (!Array.isArray(routeDateRange)) {
          return this.DEFAULT_DATE_RANGE
        }

        const defaultDateRange = this.DEFAULT_DATE_RANGE

        return [
          routeDateRange[0] || defaultDateRange[0],
          routeDateRange[1] || defaultDateRange[1]
        ]
      }
    },
    methods: {
      onDateRangeInput([from, to]) {
        const query = {
          ...this.$route.query,
        }

        if (from && to) {
          query[this.PARTNERS_DATE_FROM] = from
          query[this.PARTNERS_DATE_TO] = to
        } else {
          delete query[this.PARTNERS_DATE_FROM]
          delete query[this.PARTNERS_DATE_TO]
        }

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      getDateRangeObjects() {
        const dateRange = this.dateRange

        return [getDate(dateRange[0]), getDate(dateRange[1])]
      },
      onDateRangePrev() {
        const dateRange = this.getDateRangeObjects()

        let from = dateRange[0]
        let to = dateRange[1]
        const diff = to - from
        // from.setFullYear(from.getFullYear() - 1)
        // to.setFullYear(to.getFullYear() - 1)
        from -= diff
        to -= diff

        this.onDateRangeInput([
          this.formatDate.format(from),
          this.formatDate.format(to)
        ])
      },
      onDateRangeNext() {
        const dateRange = this.getDateRangeObjects()

        let from = dateRange[0]
        let to = dateRange[1]
        const diff = to - from

        // from.setFullYear(from.getFullYear() + 1)
        // to.setFullYear(to.getFullYear() + 1)

        from = from.getTime() + diff
        to = to.getTime() + diff

        this.onDateRangeInput([
          this.formatDate.format(from),
          this.formatDate.format(to)
        ])
      },
    },
    created() {
      console.log(this.DEFAULT_DATE_RANGE)
    }
  }

  function getDate(str) {
    return new Date(
      parseFloat(str.slice(6, 10)),
      parseFloat(str.slice(3, 5)) - 1,
      parseFloat(str.slice(0, 2)),
    )
  }
</script>

<style lang="less">

</style>
